/**
 * Collection page: page cache, prefetch, aggregated load-more.
 * Active on template-collection pages only.
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-collection')) return;

  var pageCache = new Map();
  var prefetching = new Set();

  function nextPageUrl() {
    var link = document.querySelector('[data-infinite-scrolling]:not(.disabled)');
    if (!link) link = document.querySelector('.pagination__item--next');
    if (!link) return null;
    return link.getAttribute('href') || link.dataset.href || null;
  }

  function prefetchUrl(url) {
    if (!url || pageCache.has(url) || prefetching.has(url)) return;
    prefetching.add(url);

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        pageCache.set(url, html);
      })
      .catch(function () {})
      .finally(function () {
        prefetching.delete(url);
      });
  }

  function prefetchUpcoming() {
    prefetchUrl(nextPageUrl());
  }

  function applyLoadedPage(html) {
    if (!window.halo || typeof window.halo.ajaxInfiniteScrollingMapData !== 'function') return false;
    window.halo.ajaxInfiniteScrollingMapData(html);
    return true;
  }

  function loadNextPage(url, link) {
    if (!url || !link || link.classList.contains('is-loading')) return;

    link.classList.add('is-loading');

    var loadingText = link.getAttribute('data-loading-more');
    if (loadingText) link.textContent = loadingText;

    function finish() {
      link.classList.remove('is-loading');
      var loadMoreText = link.getAttribute('data-load-more');
      if (loadMoreText) link.textContent = loadMoreText;
      if (document.querySelector('.collection-masonry') && typeof resizeAllGridItems === 'function') {
        resizeAllGridItems();
      }
      prefetchUpcoming();
    }

    if (pageCache.has(url)) {
      applyLoadedPage(pageCache.get(url));
      finish();
      return;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        pageCache.set(url, html);
        applyLoadedPage(html);
      })
      .catch(function () {})
      .finally(finish);
  }

  function patchInfiniteScroll() {
    if (!window.halo || window.halo.__collectionPagePatched) return false;
    window.halo.__collectionPagePatched = true;

    window.halo.doAjaxInfiniteScrollingGetContent = function (url, link) {
      var el = link && link.jquery ? link[0] : link;
      loadNextPage(url, el);
    };

    return true;
  }

  function initAggregatedLoadMore() {
    var grid = document.getElementById('CollectionProductGrid');
    var sentinel = document.getElementById('collection-aggregated-sentinel');
    if (!grid || !sentinel) return;

    var productList = grid.querySelector('.productListing');
    if (!productList) return;

    var collectionHandle = sentinel.dataset.collectionHandle || '';
    var batchSize = parseInt(sentinel.dataset.batch, 10) || 24;
    var sectionId = sentinel.dataset.sectionId || '';
    var nextCi = parseInt(sentinel.dataset.nextCi, 10) || 0;
    var nextPi = parseInt(sentinel.dataset.nextPi, 10) || 0;

    var seen = new Set();
    productList.querySelectorAll('[data-handle]').forEach(function (node) {
      seen.add(node.dataset.handle);
    });

    var imageRatio = sentinel.dataset.imageRatio || '';
    var portraitRatio = sentinel.dataset.portraitRatio || '';

    var batchLoading = false;
    var done = false;
    var chain = 0;
    var errors = 0;
    var maxChain = 40;
    var observer = null;

    function stop() {
      done = true;
      if (observer) observer.disconnect();
      sentinel.remove();
    }

    function sentinelVisible() {
      if (done || !sentinel.isConnected) return false;
      var rect = sentinel.getBoundingClientRect();
      return rect.top < window.innerHeight + 400 && rect.bottom > -400;
    }

    function maybeContinue(added) {
      chain = added > 0 ? 0 : chain + 1;
      if (chain >= maxChain) return;
      if (sentinelVisible()) setTimeout(loadBatch, 0);
    }

    function loadBatch() {
      if (batchLoading || done) return;
      batchLoading = true;

      var root = (window.routes && window.routes.root) || '';
      var url =
        root + '/collections/' + encodeURIComponent(collectionHandle) +
        '?view=ajax_aggregated&constraint=' +
        encodeURIComponent(
          'ci=' + nextCi + '+pi=' + nextPi + '+limit=' + batchSize +
          '+sectionId=' + sectionId + '+imageRatio=' + imageRatio + '+portraitRatio=' + portraitRatio
        );

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html.trim();

          var cursor = wrapper.querySelector('[data-aggregated-cursor]');
          var added = 0;

          wrapper.querySelectorAll('.product').forEach(function (node) {
            var handle = node.dataset.handle;
            if (handle && seen.has(handle)) return;
            if (handle) seen.add(handle);

            var li = document.createElement('li');
            li.className = node.className;
            if (handle) li.dataset.handle = handle;
            if (node.dataset.cascade) {
              li.dataset.cascade = '';
              li.style.cssText = node.style.cssText;
            }
            li.innerHTML = node.innerHTML;
            productList.appendChild(li);
            added += 1;
          });

          try {
            if (window.wishlist && window.wishlist.show && window.halo) {
              window.halo.setLocalStorageProductForWishlist();
            }
            if (typeof jQuery !== 'undefined' && window.halo && window.halo.checkNeedToConvertCurrency && window.halo.checkNeedToConvertCurrency()) {
              Currency.convertAll(window.shop_currency, jQuery('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
          } catch (e) {}

          errors = 0;

          if (!cursor) {
            stop();
            return;
          }

          var newCi = parseInt(cursor.dataset.nextCi, 10) || 0;
          var newPi = parseInt(cursor.dataset.nextPi, 10) || 0;
          var noProgress = newCi === nextCi && newPi === nextPi;

          nextCi = newCi;
          nextPi = newPi;

          if (cursor.dataset.done === 'true' || noProgress) {
            stop();
            return;
          }

          maybeContinue(added);
        })
        .catch(function () {
          errors += 1;
          if (errors >= 3) stop();
        })
        .finally(function () {
          batchLoading = false;
        });
    }

    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) loadBatch();
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(sentinel);
  }

  function initSpeculationRules() {
    if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
    if (document.querySelector('script[type="speculationrules"][data-collection-nav]')) return;

    var rules = document.createElement('script');
    rules.type = 'speculationrules';
    rules.setAttribute('data-collection-nav', '');
    rules.textContent = JSON.stringify({
      prerender: [
        {
          source: 'document',
          where: {
            selector_matches: '.pagination__list a[href], .pagination-arrow a[href]'
          },
          eagerness: 'moderate'
        }
      ]
    });
    document.head.appendChild(rules);
  }

  function init() {
    if (!patchInfiniteScroll()) {
      var attempts = 0;
      var patchInterval = setInterval(function () {
        attempts += 1;
        if (patchInfiniteScroll() || attempts > 20) clearInterval(patchInterval);
      }, 100);
    }

    prefetchUpcoming();
    initAggregatedLoadMore();
    initSpeculationRules();

    var grid = document.getElementById('CollectionProductGrid');
    if (grid) {
      new MutationObserver(function () {
        prefetchUpcoming();
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
